module.exports = __webpack_public_path__ + "static/media/bitcoin.68b5f02f.png";